import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, MoreVertical, Flag, Ban } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface ChatHeaderProps {
  name: string;
  photo?: string;
  onBlock?: () => void;
  onReport?: () => void;
}

export function ChatHeader({ name, photo, onBlock, onReport }: ChatHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-3 p-3 border-b border-brand-border bg-brand-surface">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => navigate('/dashboard')}
        className="shrink-0 text-brand-muted hover:text-white"
      >
        <ArrowLeft className="w-5 h-5" />
      </Button>

      <div className="flex items-center gap-3 flex-1 min-w-0">
        {photo ? (
          <img
            src={photo}
            alt={name}
            className="w-10 h-10 rounded-full object-cover border border-brand-border"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-brand-highlight flex items-center justify-center">
            <span className="text-brand-muted font-medium text-sm">
              {name.charAt(0).toUpperCase()}
            </span>
          </div>
        )}

        <div className="flex-1 min-w-0">
          <h2 className="font-semibold text-white truncate">{name}</h2>
        </div>
      </div>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="shrink-0 text-brand-muted hover:text-white">
            <MoreVertical className="w-5 h-5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={onReport} className="text-amber-600">
            <Flag className="w-4 h-4 mr-2" />
            Report
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={onBlock} className="text-red-600">
            <Ban className="w-4 h-4 mr-2" />
            Block
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
